const DUCK_DUCK_GO_REGEX = /(duckduckgo|ddg)/i;
const FACEBOOK_REGEX = /(fb_iab|fb4a|fbav|fban|fbss|fbdv|fblc|fbid)/i;
const WEBVIEW_REGEX = /(; wv|Version\/4\.0)/i;
const SNAPCHAT_REGEX = /(snapchat)/i;
const AVG_REGEX = /(avg)/i;
const AVAST_REGEX = /(avast)/i;
export const UNSUPPORTED_BROWSERS_REGEXES = [
    DUCK_DUCK_GO_REGEX,
    FACEBOOK_REGEX,
    WEBVIEW_REGEX,
    SNAPCHAT_REGEX,
    AVG_REGEX,
    AVAST_REGEX,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQnJvd3NlclN1cHBvcnQuY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL3VzZUJyb3dzZXJTdXBwb3J0L3VzZUJyb3dzZXJTdXBwb3J0LmNvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLGtCQUFrQixHQUFHLG1CQUFtQixDQUFDO0FBQy9DLE1BQU0sY0FBYyxHQUFHLDhDQUE4QyxDQUFDO0FBQ3RFLE1BQU0sYUFBYSxHQUFHLHVCQUF1QixDQUFDO0FBQzlDLE1BQU0sY0FBYyxHQUFHLGFBQWEsQ0FBQztBQUNyQyxNQUFNLFNBQVMsR0FBRyxRQUFRLENBQUM7QUFDM0IsTUFBTSxXQUFXLEdBQUcsVUFBVSxDQUFDO0FBRS9CLE1BQU0sQ0FBQyxNQUFNLDRCQUE0QixHQUFhO0lBQ3BELGtCQUFrQjtJQUNsQixjQUFjO0lBQ2QsYUFBYTtJQUNiLGNBQWM7SUFDZCxTQUFTO0lBQ1QsV0FBVztDQUNaLENBQUMifQ==